import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Hero() {
  const {
    t,
    getPath
  } = useLanguage();
  return <section className="relative min-h-screen w-full overflow-hidden px-4 pt-24 pb-16 md:py-0 flex items-center" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-147">
      {/* Subtle background accent */}
      <div className="absolute inset-0 overflow-hidden opacity-20" data-id="element-148">
        <div className="absolute top-1/4 right-1/4 w-[600px] h-[600px] rounded-full blur-3xl" style={{
        background: 'radial-gradient(circle, var(--accent) 0%, transparent 70%)'
      }} data-id="element-149" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col md:flex-row items-center justify-center gap-8 md:gap-12 lg:gap-16" data-id="element-150">
        {/* Left side - Content */}
        <div className="w-full md:flex-1 text-center md:text-left" data-id="element-151">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="mb-6 inline-flex items-center gap-2 rounded-full px-4 py-2 border" style={{
          borderColor: 'var(--border)',
          backgroundColor: 'var(--bg-secondary)'
        }} data-id="element-152">
            <span className="text-sm font-medium" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-153">
              {t('hero.badge')}
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mb-6 text-4xl font-bold leading-tight tracking-tight md:text-5xl lg:text-6xl" style={{
          color: 'var(--text-primary)'
        }} data-id="element-154">
            {t('hero.title')}
            <br data-id="element-155" />
            <span style={{
            color: 'var(--accent)'
          }} data-id="element-156">
              {t('hero.titleHighlight')}
            </span>
          </motion.h1>

          {/* Video - Mobile only */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="block md:hidden mb-8 rounded-xl overflow-hidden shadow-2xl border border-[var(--border)]" data-id="element-157">
            <video src="https://cdn.magicpatterns.com/uploads/kq3iSzows88vpaDd5hdwuo/60761033.undefined" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-158" />
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mb-6 max-w-lg mx-auto md:mx-0 text-lg md:text-xl font-medium" style={{
          color: 'var(--text-primary)'
        }} data-id="element-159">
            {t('hero.subtitle')}
          </motion.h2>

          <motion.ul initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.35
        }} className="mb-8 space-y-2 text-sm md:text-base" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-160">
            <li className="flex items-center gap-2 justify-center md:justify-start" data-id="element-161">
              <div className="w-1.5 h-1.5 rounded-full bg-green-500" data-id="element-162" />
              {t('hero.bullet1')}
            </li>
            <li className="flex items-center gap-2 justify-center md:justify-start" data-id="element-163">
              <div className="w-1.5 h-1.5 rounded-full bg-green-500" data-id="element-164" />
              {t('hero.bullet2')}
            </li>
            <li className="flex items-center gap-2 justify-center md:justify-start" data-id="element-165">
              <div className="w-1.5 h-1.5 rounded-full bg-green-500" data-id="element-166" />
              {t('hero.bullet3')}
            </li>
          </motion.ul>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-167">
            <motion.a href={getPath('#consultation')} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="group flex items-center justify-center gap-2 rounded-lg px-8 py-4 font-semibold transition-all" style={{
            backgroundColor: 'var(--accent)',
            color: '#FFFFFF'
          }} data-id="element-168">
              {t('hero.cta')}
              <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-169" />
            </motion.a>
          </motion.div>
        </div>

        {/* Right side - Video (Desktop only) */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="hidden md:flex md:flex-1 items-center justify-center h-full" data-id="element-170">
          <div className="relative w-full max-w-2xl mx-auto rounded-2xl overflow-hidden shadow-2xl border border-[var(--border)]" data-id="element-171">
            <video src="https://cdn.magicpatterns.com/uploads/kq3iSzows88vpaDd5hdwuo/60761033.undefined" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-172" />
          </div>
        </motion.div>
      </div>
    </section>;
}